import axios from "axios";
import AppSettings from "../appsettings";

const API_BASE = `${AppSettings.API_BASE_URL}/employees`;

const EmployeeApiService = {
  // Get all employees
  getAllEmployees: async () => {
    try {
      const response = await axios.get(`${API_BASE}`);
      return response.data;
    } catch (error) {
      console.error("❌ Failed to fetch employees:", error);
      throw error;
    }
  },

  // Get employee by ID
  getEmployeeById: async (id) => {
    try {
      const response = await axios.get(`${API_BASE}/${id}`);
      return response.data;
    } catch (error) {
      console.error("❌ Failed to fetch employee:", error);
      throw error;
    }
  },

  // Create new employee
  createEmployee: async (employeeData) => {
    try {
      const response = await axios.post(`${API_BASE}`, employeeData);
      return response.data;
    } catch (error) {
      console.error("❌ Failed to create employee:", error);
      throw error;
    }
  },

  // Update employee
  updateEmployee: async (id, employeeData) => {
    try {
      const response = await axios.put(`${API_BASE}/${id}`, employeeData);
      return response.data;
    } catch (error) {
      console.error("❌ Failed to update employee:", error);
      throw error;
    }
  },

  // Delete employee
  deleteEmployee: async (id) => {
    try {
      const response = await axios.delete(`${API_BASE}/${id}`);
      return response.data;
    } catch (error) {
      console.error("❌ Failed to delete employee:", error);
      throw error;
    }
  },
};

export default EmployeeApiService;
